// 业务划分，用于区分不同业务的上报 https://mindverse.feishu.cn/sheets/DoVIsBeBVhdtiFtZZgVcWbVanXh

export enum EBiz {
  leftMenu = 'leftMenu',
  marketplace = 'marketplace',
  myGenius = 'myGenius',
  tool = 'tool', //deprecated
  showContent = 'showContent', // deprecated
  genius = 'genius',
  persona = 'persona',
  knowledge = 'knowledge',
  skill = 'skill',
  memory = 'memory',
  publish = 'publish',
  chat_container = 'chatContainer',
  chat_mode = 'chatMode',
  ab_test = 'ab_test'
}
